module.exports = __webpack_public_path__ + "static/img/fc-flyer.49841f5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/fc-flyer.jpg
// module id = vCEY
// module chunks = 0